import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    TextField,
    Typography,
    useTheme
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseRoundedIcon from "@mui/icons-material/Close";
import * as React from "react";
import {useTranslation} from "react-i18next";
import {
    UserLegalEntitiesOrDealersInputGroup
} from "../../../component/UserLegalEntitiesOrDealersInputGroup/UserLegalEntitiesOrDealersInputGroup";
import {PaOrder} from "../constants/interfaces";


const PaOrderDetailModal = (props: any) => {
    const {t} = useTranslation(['salesmarketing'], {keyPrefix: 'paOrders'});
    const {order}: {order: PaOrder} = props;
    const theme = useTheme();

    return (
        <Dialog scroll={"paper"} maxWidth={"lg"} disableEscapeKeyDown fullWidth={true} open={props.open}
                onClose={() => {
                    return;
                }}>
            <DialogTitle>
                <Typography fontWeight={"bold"} color={"primary"}>
                    {t('details.title')}
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={() => {
                        props.handleClose();
                    }}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                    }}
                >
                    <CloseRoundedIcon/>
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Grid container rowSpacing={3} columnSpacing={3}>
                    <UserLegalEntitiesOrDealersInputGroup dealerId={order!.dealerId}
                                                          tenantId={order!.tenantId}/>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('cigNumber')}
                            value={order.cig ?? '--'}
                            margin="dense"
                            variant="standard"
                            inputProps={{
                                readOnly: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('cupNumber')}
                            value={order.cup?? '--'}
                            margin="dense"
                            variant="standard"
                            inputProps={{
                                readOnly: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('orderId')}
                            value={order.orderId ?? '--'}
                            margin="dense"
                            variant="standard"
                            inputProps={{
                                readOnly: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('description')}
                            value={order.description ?? '--'}
                            margin="dense"
                            variant="standard"
                            inputProps={{
                                readOnly: true
                            }}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions style={{backgroundColor: theme.palette.neutral.main}}>
                <Button color={"accent"}
                        onClick={() => props.handleClose()}>{t('details.close')}</Button>
            </DialogActions>
        </Dialog>
    )
}
export default PaOrderDetailModal;